import React from 'react';
import ApiService from '../../../services/ApiService';
import { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import CustomTittle from '../../../components/Elements/customTittle/customTittle';
import CourseDetail from '../../coursDetail/courseDetail';
import { API_URL } from '../../../config';
import axios from 'axios';
import UserDetailPopUp from '../../../components/Elements/userDetailPopUp/userDetailPopUp';
import CustomRedText from '../../../components/Elements/redText/redText';
import AcceptInput from '../../chooseUserBuy/accept/accept';
import CustomInput from '../../../components/Elements/input/customInput';
import CustomLink from '../../../components/Elements/Link/link';
import CustomButtons from '../../../components/Elements/Buttons/customButton';
// import GetContract from './getContract/getContract';
// import AcceptInput from '../../chooseUserBuy/accept/accept';
// import CustomLink from '../../../components/Elements/Link/link';
// import CustomButtons from '../../../components/Elements/Buttons/customButton';
import "./awaitContractConfirm.css"



let idLoader;
 
const AwaitContractConfirm = (props) => {
    const history = useHistory();
    const apiService = ApiService.getInstance();
    const proxySendURL = `${API_URL}ProxySend`
    const config = { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } };
    let parcipientName =  localStorage.getItem('userName');   
    if(parcipientName == null){
        parcipientName =  localStorage.getItem('payerName');    
    }
    const [msg, setMsg] = useState("UMOWA JEST W TRAKCIE TWORZENIA...")
    const [choosenAmount, setChoosenAmount] = useState(0)
    let key = localStorage.getItem('keyURL')
    let userID = localStorage.getItem('usersID')
   
   
    function registerClick(){
        props.next()
    }
    let amount = 0;
   const startLoaderTask = (taskConfig = null) => {
        if (
            typeof window.edsLoader === 'object' &&
            typeof window.edsLoader.startTask === 'function'
        ) {
            return window.edsLoader.startTask(taskConfig);
        } else {
            return false;
        }
    };
    const stopLoaderTask = (taskId) => {
        if (
            typeof window.edsLoader === 'object' &&
            typeof window.edsLoader.endTask === 'function'
        ) {
            return window.edsLoader.endTask(taskId);
        } else {
            return false;
        }
    };

    const formData = {
        type: 'Order',
        body: {
            guid:props.trackingId,
            allInstallments: props.installment.paymentShedule  ,
             paymentMethodsDVID: parseInt(props.data.choosenPaymentOption),
             paymentMethodsP24:props.data.paymentP24,
             paymentCardID: props.data.card,
               buyerNIP: props.data.nip.length != 0?props.data.nip:null,
             purchaseKey: key,
             returnUrl: "https://panelklienta.egurrola.com/ThankYou",
             current_LocalizationsID: -1,
            contractPeriodFrom: props.installment.expirationDateFrom,
             usersID: props.participantUsers != null? props.participantUsers.usersID :userID, // uczestnik
             payer_UsersID: +userID,                            // płatnik
             productsID: props.installment.productsID,
             coursesHeadingsID: parseInt(localStorage.getItem('coursesHeadingsID')),
             contractAmount:  props.data.choosenAmount,//calculateAmiunt(),//props.installment.currentPrice,
             paymentStatusesDVID: 1,
             arrayOfSelectedInstallments: props.data.listOfInstallment.toString(),
             entryFee: props.installment.entryFee ? props.installment.entryFee.price : 0,
             promotionsSalesIDList: `${props.installment.promotionsSalesIDList}`,
             dataTo: props.installment.expirationDateTo,
        },
    };

    let globalResponse;
    const methodProxySend = () => {

        let urlParams = "https://panelklienta.egurrola.com/ThankYou"
        const formData = {
            type: 'Order',
            body: {
                guid:props.trackingId,
                allInstallments: props.installment.paymentShedule  ,
                 paymentMethodsDVID: parseInt(props.data.choosenPaymentOption),
                 paymentMethodsP24:props.data.paymentP24,
                 paymentCardID: props.data.card,
                   buyerNIP: props.data.nip.length != 0?props.data.nip:null,
                 purchaseKey: key,
                 returnUrl: urlParams,
                 current_LocalizationsID: -1,
                contractPeriodFrom: props.installment.expirationDateFrom,
                 usersID: props.participantUsers != null? props.participantUsers.usersID :userID, // uczestnik
                 payer_UsersID: +userID,                            // płatnik
                 productsID: props.installment.productsID,
                 coursesHeadingsID: parseInt(localStorage.getItem('coursesHeadingsID')),
                 contractAmount:  props.data.choosenAmount,//calculateAmiunt(),//props.installment.currentPrice,
                 paymentStatusesDVID: 1,
                 arrayOfSelectedInstallments: props.data.listOfInstallment.toString(),
                 entryFee: props.installment.entryFee ? props.installment.entryFee.priceDiscount : 0,
                 promotionsSalesIDList: `${props.installment.promotionsSalesIDList}`,
                 dataTo: props.installment.expirationDateTo,
            },
        };
        idLoader = startLoaderTask()
        axios
            .post(proxySendURL, formData, config)
            .then((response) => {
                globalResponse = response.data.requestId;
                if(response.data.recheck){
                    methodProxyGetMessage();
                } else {
                    document.getElementsByClassName("eds_loader_container")[0].style.display = "none"
                    if(response.data.message === 'Other created'){
                        
                        setMsg("Taka umowa została już utworzona")
                        
                    }
                    if(response.data.message === "Fault"){
                        setMsg("Wystąpił problem. Skontaktuj się z BOK.")
                       
                    } 
                    if(response.data.message == 'Other requested'){
                        // umowa jest w trakcie procesowania uder create
                        setMsg('Umowa jest w trakcie tworzenia.');
                  
                        methodProxyGetMessage();
                    }
                }
            })
            .catch(function (error) {
            console.log(error)
                if (error.response.status == 401) {
                    // history.push('/Error_ogolny');
                }
            });
    };

    const methodProxyGetMessage = () => {
        const proxyGetMessageURL = `${API_URL}ProxyGetMessage?requestId=` + globalResponse;
        axios
            .get(proxyGetMessageURL, config)
            .then((proxyGetMessageUrlResponse) => {
               
                if (proxyGetMessageUrlResponse.data.recheck == false) {
                    document.getElementsByClassName("eds_loader_container")[0].style.display = "none"
                    if(proxyGetMessageUrlResponse.data.responseBody.status == 400){
                        history.push('/Error_ogolny');
                     
                    }
              
                    if(proxyGetMessageUrlResponse.data.responseBody.status == 200){
                        stopLoaderTask(idLoader);
                      
                        localStorage.setItem('contractSygnature',proxyGetMessageUrlResponse.data.responseBody.body.contractSygnature);
                        props.next()
                
                    } else if(proxyGetMessageUrlResponse.data.responseBody.body.key === 20){
                      
                        history.push(`/Potwierdzenie_zakupu/${proxyGetMessageUrlResponse.data.responseBody.body.sessionID}`);
                    }else{
                        setMsg('Podczas tworzenia umowy wystąpił problem. Skontaktuj się z buirem obsługi klienta w celu dalszych wyjaśnień.');
                    }
                } else if (proxyGetMessageUrlResponse.data.recheck == true) {
                    setTimeout(() => methodProxyGetMessage(), 10000);
                }
            })
            .catch(function (error) {
                if (error.response != null) {
                    if (error.response.status == 401) {
                        history.push('/Error_ogolny');
                    }
                } else {
                    // window.location.replace(
                    //     'https://aden-eds-portal-dev.azurewebsites.net/#/Error_ogolny'
                    // );
                }
            });
    };
    function getUserReapet(){
        apiService.apiGet('UserGet', (response) => {
            if(response.success){
                formData.body.usersID = response.data.usersID
                methodProxySend()
            }else{
                getUserReapet()
            }
            });
    }
    useEffect(()=>{
       
            getUserReapet()
           
         }
         
    ,[])
//     useEffect(()=>{
//         methodProxySend()
//    },[userID])

    return <> 
      <div className='contracts_content'>
      <div className='contractSummary_Await'>     
    <div className='contractSummary_wrapper'>
    <CustomTittle>Poniżej znajdziesz umowy do pobrania</CustomTittle>
    <div className='contracts_wrapperStatus'>
        <CustomTittle>Status:</CustomTittle>
        <CustomRedText>{msg}</CustomRedText>
        {/* <div className='acceptContract'>
            <p className='acceptContractTittle'>Przeczytaj je, a następnie zaakecptuj zgody</p>
            <div className='acceptrContractLabel'><AcceptInput onAccept={()=>{
                props.acceptCondition({...props.condition,
                    terms: !props.condition.terms

                })
            }} label="Akceptuje warunki umowy"></AcceptInput></div>
            <div className='acceptrContractLabel'><AcceptInput onAccept={()=>{
                props.acceptCondition({...props.condition,
                    statuseContract: !props.condition.statuseContract

                })
            }} label="Akceptuje"></AcceptInput><CustomLink link="/#">Regulamin</CustomLink> <p className='pLabel'>i</p> <CustomLink link="/#">Status</CustomLink></div>
            <div className='acceptrContractLabel'><AcceptInput onAccept={()=>{
                props.acceptCondition({...props.condition,
                    accept: !props.condition.accept

                })
            }} label="Zgadzam się na..."></AcceptInput></div>
        </div> */}

        {msg == "Twoja umowa jest gotowa! Możesz przejść dalej"?<CustomButtons clickFunction={registerClick} size="big" classButton="solid">POTWIERDZAM ZAWARCIE UMOWY</CustomButtons>:""}
    </div>
    </div>
        </div>
    <div className='columDetials'>  
            <div className='columDetials_wrapper'>
                        <CustomTittle>Szczegóły zamówienia  </CustomTittle>
                        <CourseDetail  wrapNavigator={props.wrapNavigator}  setWrapNavigator={props.setWrapNavigator} setHeader={(e)=>{props.setHeader(e)}} header={props.header}></CourseDetail>
                        <UserDetailPopUp onclick={()=>{props.setNavigator(1,"chooseUser")}} title="Uczestnik:" label={parcipientName} icon={<svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.3107 0.821234C14.1866 0.836124 14.0714 0.892748 13.9838 0.981809L5.72673 9.23891C5.64421 9.32133 5.58996 9.42774 5.57184 9.5428L5.20489 11.9283C5.179 12.1017 5.23733 12.2771 5.36186 12.4006C5.48649 12.524 5.66243 12.5807 5.83562 12.5532L8.221 12.1863C8.33614 12.1681 8.44256 12.1139 8.52499 12.0315L16.7821 3.77437C16.884 3.67127 16.9411 3.53223 16.9411 3.38732C16.9411 3.2424 16.884 3.10326 16.7821 3.00026L14.7637 0.981838C14.6452 0.861763 14.4783 0.802579 14.3107 0.821263L14.3107 0.821234ZM14.3737 2.14586L15.6123 3.39014L7.87121 11.1313L6.40896 11.3549L6.6326 9.88699L14.3737 2.14586ZM0.921326 2.28917C0.785505 2.3034 0.659824 2.36761 0.568699 2.46938C0.477574 2.57115 0.427474 2.70308 0.428231 2.83966V16.785C0.428231 16.9309 0.486276 17.0709 0.589469 17.1742C0.692756 17.2774 0.83276 17.3354 0.978711 17.3354H14.924C15.07 17.3354 15.21 17.2774 15.3133 17.1742C15.4165 17.0709 15.4745 16.9309 15.4745 16.785V7.24343C15.4766 7.09613 15.4195 6.95405 15.316 6.84916C15.2125 6.74417 15.0713 6.68517 14.924 6.68517C14.7766 6.68517 14.6354 6.74417 14.532 6.84916C14.4285 6.95406 14.3714 7.09614 14.3735 7.24343V16.2345H1.52908V3.3901H10.5202C10.6675 3.39219 10.8096 3.33509 10.9144 3.23161C11.0193 3.12823 11.0784 2.98701 11.0784 2.8396C11.0784 2.69221 11.0193 2.55108 10.9144 2.44759C10.8095 2.34412 10.6675 2.28702 10.5202 2.28911H0.978638C0.959574 2.28816 0.940415 2.28816 0.921256 2.28911L0.921326 2.28917Z" fill="#CC0033"/>
                </svg>
                }></UserDetailPopUp>
                <UserDetailPopUp onclick={()=>{props.setNavigator(2,"data")}} title="Data rozpoczęcia:" label={props.start.split("-")[2] +"-"+ props.start.split("-")[1] +"-"+ props.start.split("-")[0]} icon={<svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.3107 0.821234C14.1866 0.836124 14.0714 0.892748 13.9838 0.981809L5.72673 9.23891C5.64421 9.32133 5.58996 9.42774 5.57184 9.5428L5.20489 11.9283C5.179 12.1017 5.23733 12.2771 5.36186 12.4006C5.48649 12.524 5.66243 12.5807 5.83562 12.5532L8.221 12.1863C8.33614 12.1681 8.44256 12.1139 8.52499 12.0315L16.7821 3.77437C16.884 3.67127 16.9411 3.53223 16.9411 3.38732C16.9411 3.2424 16.884 3.10326 16.7821 3.00026L14.7637 0.981838C14.6452 0.861763 14.4783 0.802579 14.3107 0.821263L14.3107 0.821234ZM14.3737 2.14586L15.6123 3.39014L7.87121 11.1313L6.40896 11.3549L6.6326 9.88699L14.3737 2.14586ZM0.921326 2.28917C0.785505 2.3034 0.659824 2.36761 0.568699 2.46938C0.477574 2.57115 0.427474 2.70308 0.428231 2.83966V16.785C0.428231 16.9309 0.486276 17.0709 0.589469 17.1742C0.692756 17.2774 0.83276 17.3354 0.978711 17.3354H14.924C15.07 17.3354 15.21 17.2774 15.3133 17.1742C15.4165 17.0709 15.4745 16.9309 15.4745 16.785V7.24343C15.4766 7.09613 15.4195 6.95405 15.316 6.84916C15.2125 6.74417 15.0713 6.68517 14.924 6.68517C14.7766 6.68517 14.6354 6.74417 14.532 6.84916C14.4285 6.95406 14.3714 7.09614 14.3735 7.24343V16.2345H1.52908V3.3901H10.5202C10.6675 3.39219 10.8096 3.33509 10.9144 3.23161C11.0193 3.12823 11.0784 2.98701 11.0784 2.8396C11.0784 2.69221 11.0193 2.55108 10.9144 2.44759C10.8095 2.34412 10.6675 2.28702 10.5202 2.28911H0.978638C0.959574 2.28816 0.940415 2.28816 0.921256 2.28911L0.921326 2.28917Z" fill="#CC0033"/>
                </svg>
                }></UserDetailPopUp>
                <UserDetailPopUp onclick={()=>{props.setNavigator(3,"variant")}} title="Wariant cenowy:" hint={props.data.varaintHint} label={props.data.variantTittle} icon={<svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.3107 0.821234C14.1866 0.836124 14.0714 0.892748 13.9838 0.981809L5.72673 9.23891C5.64421 9.32133 5.58996 9.42774 5.57184 9.5428L5.20489 11.9283C5.179 12.1017 5.23733 12.2771 5.36186 12.4006C5.48649 12.524 5.66243 12.5807 5.83562 12.5532L8.221 12.1863C8.33614 12.1681 8.44256 12.1139 8.52499 12.0315L16.7821 3.77437C16.884 3.67127 16.9411 3.53223 16.9411 3.38732C16.9411 3.2424 16.884 3.10326 16.7821 3.00026L14.7637 0.981838C14.6452 0.861763 14.4783 0.802579 14.3107 0.821263L14.3107 0.821234ZM14.3737 2.14586L15.6123 3.39014L7.87121 11.1313L6.40896 11.3549L6.6326 9.88699L14.3737 2.14586ZM0.921326 2.28917C0.785505 2.3034 0.659824 2.36761 0.568699 2.46938C0.477574 2.57115 0.427474 2.70308 0.428231 2.83966V16.785C0.428231 16.9309 0.486276 17.0709 0.589469 17.1742C0.692756 17.2774 0.83276 17.3354 0.978711 17.3354H14.924C15.07 17.3354 15.21 17.2774 15.3133 17.1742C15.4165 17.0709 15.4745 16.9309 15.4745 16.785V7.24343C15.4766 7.09613 15.4195 6.95405 15.316 6.84916C15.2125 6.74417 15.0713 6.68517 14.924 6.68517C14.7766 6.68517 14.6354 6.74417 14.532 6.84916C14.4285 6.95406 14.3714 7.09614 14.3735 7.24343V16.2345H1.52908V3.3901H10.5202C10.6675 3.39219 10.8096 3.33509 10.9144 3.23161C11.0193 3.12823 11.0784 2.98701 11.0784 2.8396C11.0784 2.69221 11.0193 2.55108 10.9144 2.44759C10.8095 2.34412 10.6675 2.28702 10.5202 2.28911H0.978638C0.959574 2.28816 0.940415 2.28816 0.921256 2.28911L0.921326 2.28917Z" fill="#CC0033"/>
                </svg>
                }></UserDetailPopUp>
                {props.discountD.length !=0?<UserDetailPopUp onclick={()=>{props.setNavigator(4,"payment")}} title="Kod rabatowy:"  label={"-"+props.discountD.discountValue+"%"} icon={<svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.3107 0.821234C14.1866 0.836124 14.0714 0.892748 13.9838 0.981809L5.72673 9.23891C5.64421 9.32133 5.58996 9.42774 5.57184 9.5428L5.20489 11.9283C5.179 12.1017 5.23733 12.2771 5.36186 12.4006C5.48649 12.524 5.66243 12.5807 5.83562 12.5532L8.221 12.1863C8.33614 12.1681 8.44256 12.1139 8.52499 12.0315L16.7821 3.77437C16.884 3.67127 16.9411 3.53223 16.9411 3.38732C16.9411 3.2424 16.884 3.10326 16.7821 3.00026L14.7637 0.981838C14.6452 0.861763 14.4783 0.802579 14.3107 0.821263L14.3107 0.821234ZM14.3737 2.14586L15.6123 3.39014L7.87121 11.1313L6.40896 11.3549L6.6326 9.88699L14.3737 2.14586ZM0.921326 2.28917C0.785505 2.3034 0.659824 2.36761 0.568699 2.46938C0.477574 2.57115 0.427474 2.70308 0.428231 2.83966V16.785C0.428231 16.9309 0.486276 17.0709 0.589469 17.1742C0.692756 17.2774 0.83276 17.3354 0.978711 17.3354H14.924C15.07 17.3354 15.21 17.2774 15.3133 17.1742C15.4165 17.0709 15.4745 16.9309 15.4745 16.785V7.24343C15.4766 7.09613 15.4195 6.95405 15.316 6.84916C15.2125 6.74417 15.0713 6.68517 14.924 6.68517C14.7766 6.68517 14.6354 6.74417 14.532 6.84916C14.4285 6.95406 14.3714 7.09614 14.3735 7.24343V16.2345H1.52908V3.3901H10.5202C10.6675 3.39219 10.8096 3.33509 10.9144 3.23161C11.0193 3.12823 11.0784 2.98701 11.0784 2.8396C11.0784 2.69221 11.0193 2.55108 10.9144 2.44759C10.8095 2.34412 10.6675 2.28702 10.5202 2.28911H0.978638C0.959574 2.28816 0.940415 2.28816 0.921256 2.28911L0.921326 2.28917Z" fill="#CC0033"/>
                </svg>
                }></UserDetailPopUp>:""}
                <div className='contractSummary'>
                    <div className='Installment_summaryValue'><p className='contractSummary_tittle'>Wartość:</p> <p className='contractSummary_value'>{props.data.summary.value} zł</p></div>
                    <div className='Installment_summaryValue'><p className='contractSummary_tittle'>Opłata Wpisowa:</p><p className='contractSummary_value' >{props.data.summary.entryFee} zł</p></div>
                    <div className='Installment_summaryValue'><p className='contractSummary_tittle'>Rabat:</p> <p className='contractSummary_value'>-{props.data.summary.discount} zł</p></div>             
                    <div className='contractSummary_summaryValue'><CustomTittle>DO ZAPŁATY:</CustomTittle> <CustomTittle>{props.data.summary.summary} zł</CustomTittle></div>             
                  
                </div>
            </div>
        </div></div>
    </>;
    }

export default AwaitContractConfirm;
